import { useEffect } from 'react';

var useOnClickOutside = function useOnClickOutside(refs, handler) {
  if (handler === void 0) {
    handler = function handler(event) {
      return void 0;
    };
  }

  useEffect(function () {
    var refArray = Array.isArray(refs) ? refs : [refs];

    var listener = function listener(event) {
      var goAhead = refArray.reduce(function (_goAhead, ref) {
        if (!ref.current || ref.current.contains(event.target)) {
          return false;
        }

        return _goAhead;
      }, true);

      if (!goAhead) {
        return;
      }

      event.stopPropagation();
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
};

export { useOnClickOutside };